let abTastyLoaded = false;

export const loadABTasty = () => {
  if (abTastyLoaded) return;

  const script = document.createElement("script");

  script.src = "https://try.abtasty.com/def25e56c25342888ef09590de70cef4.js";
  script.async = true;

  script.onload = () => {
    console.log("AB Tasty loaded");
  };

  document.head.appendChild(script);

  abTastyLoaded = true;
};